<template>
    <div class="card">
        <div class="card-body">
            <ul class="nav nav-tabs nav-justified" id="myTab" role="tablist">
                 <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 'cf-disputes-flow' }"
                        id="creditfixrr-dispute-flow-justified"
                        data-toggle="tab"
                        href="#creditfixrr-dispute-flow"
                        @click="shiftTab('cf-disputes-flow')"
                        role="tab"
                        aria-controls="creditfixrr-dispute-flow"
                        aria-selected="true">Creditfixrr Dispute Flow
                    </a>
                </li>
                <!-- <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 6 }"
                        id="late-letters-justified"
                        data-toggle="tab"
                        href="#late-letters"
                        @click="shiftTab(6)"
                        role="tab"
                        aria-controls="late-letters"
                        aria-selected="true">Late Payments
                    </a>
                </li>
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 7 }"
                        id="bankruptcy-letters-justified"
                        data-toggle="tab"
                        href="#bankruptcy-letters"
                        @click="shiftTab(7)"
                        role="tab"
                        aria-controls="bankruptcy-letters"
                        aria-selected="true">Bankruptcy
                    </a>
                </li> -->
                <li class="nav-item">
                    <a
                        class="nav-link"
                        :class="{ active: disputeCenterActiveTab == 'misc-letters' }"
                        id="misc-letters-justified"
                        data-toggle="tab"
                        href="#misc-letters"
                        @click="shiftTab('misc-letters')"
                        role="tab"
                        aria-controls="misc-letters"
                        aria-selected="false">Misc Letters
                    </a>

                </li>

            </ul>

            <!-- Tab panes -->
            <div class="tab-content">
                <KeepAlive>
                <div class="tab-pane active fade show" id="creditfixrr-dispute-flow" role="tabpanel" aria-labelledby="creditfixrr-dispute-flow-justified">
                    <div v-if="isLoading" class="text-center my-5">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <template v-else-if="disputeCenterActiveTab == 'cf-disputes-flow'" v-for="(letterList, title) in letters[disputeCenterActiveTab]">
                        <h4 class="text-center font-weight-bolder text-primary">{{ title }}</h4>
                        <div v-if="title == 'Round 1'" class="row mx-auto">
                            <div class="col-lg-3 col-md-3 col-12 mx-auto">
                                <a href="#" type="submit" data-toggle="modal" data-target="#round1_tutorial_modal_video"
                                    class="btn-sm btn-outline-primary">
                                    <i data-feather="film"></i>
                                    Round-1 Dispute Flow Overview
                                </a>
                            </div>
                        </div>
                        <div v-if="title == 'Round 2'" class="row mx-auto">
                            <div class="col-lg-3 col-md-3 col-12 mx-auto">
                                <a href="#" type="submit" data-toggle="modal" data-target="#round2_tutorial_modal_video"
                                    class="btn-sm btn-outline-primary">
                                    <i data-feather="film"></i>
                                    Round-2 Dispute Flow Overview
                                </a>
                            </div>
                        </div>
                        <swiper
                            :slides-per-view="4"
                            :space-between="60"
                            @swiper="onSwiper"
                            @slideChange="onSlideChange"
                            :navigation="true"
                            :modules="modules"
                            :pagination="{
                                type: 'fraction',
                                clickable: true,
                            }"
                            :breakpoints="{
                                '1200': {
                                    slidesPerView: 4,
                                    spaceBetween: 60,
                                },
                                '991': {
                                    slidesPerView: 3,
                                    spaceBetween: 60,
                                },
                                '576': {
                                    slidesPerView: 2,
                                    spaceBetween: 60,
                                },
                                '0': {
                                    slidesPerView: 1,
                                    spaceBetween: 60,
                                }
                            }"
                            class="grid-view px-5 mt-0"
                        >
                            <swiper-slide v-for="(letter, index) in letterList">
                                <div class="card ecommerce-card">
                                    <div class="item-img text-center">
                                        <a href="#" style="position:relative;" id="letter_image_fluid">
                                            <img :src="letter.image_url" class="img-fluid" alt="img-placeholder" v-if="letter.image_url != null"/>
                                            <img :src="letter.letter_image" class="img-fluid" alt="img-placeholder" v-else/>
                                            <div class="videoPlayBox" @click="openVideModel(letter.video_type, letter.letter_video,letter.name,letter.video_media_url)">
                                                <vue-feather width="28px" height="28px" type="play-circle" class="letters_icons"></vue-feather>
                                            </div>
                                        </a>
                                    </div>
                                    <div class="card-body">
                                        <div class="item-wrapper">
                                            <div class="item-rating">
                                                {{ letter.letter_type }}
                                            </div>
                                            <div class="item-cost">
                                                <p class="item-price">
                                                    <transition >
                                                        <span v-if="letter.dispute_flow_round === 'Pre-Dispute'" class="badge badge-secondary badge-glow company-name">
                                                            {{ letter.dispute_flow_round }}
                                                        </span>
                                                        <span v-else-if="letter.dispute_flow_round === 'Round 1'" class="badge badge-info badge-glow company-name">
                                                            {{ letter.dispute_flow_round }}
                                                        </span>
                                                        <span v-else-if="letter.dispute_flow_round === 'Round 2'" class="badge badge-success badge-glow company-name">
                                                            {{ letter.dispute_flow_round }}
                                                        </span>
                                                        <span v-else-if="letter.dispute_flow_round === 'Round 3'" class="badge badge-primary badge-glow company-name">
                                                            {{ letter.dispute_flow_round }}
                                                        </span>
                                                        <span v-else-if="letter.dispute_flow_round === 'Round 4'" class="badge badge-warning badge-glow company-name">
                                                            {{ letter.dispute_flow_round }}
                                                        </span>
                                                        <span v-else-if="letter.dispute_flow_round === 'Complaint'" class="badge badge-danger badge-glow company-name">
                                                            {{ letter.dispute_flow_round }}
                                                        </span>

                                                    </transition>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="item-name">
                                            <a href="">
                                                {{ letter.name }}
                                            </a>
                                        </div>
                                    </div>
                                    <div class="item-options text-center" v-if="caneditallletter">
                                        <a class="btn btn-success btn-cart" @click="toggleEditor(letter.id)">
                                            <i data-feather="edit"></i>
                                            <span class="add-to-cart">Edit Letter</span>
                                        </a>
                                    </div>
                                    <div v-if="canCreateLetter" class="item-options text-center">
                                        <a :href="routes.letterTutorialUrl.replace(':letter_id', letter.id)" class="btn btn-light btn-cart">
                                            <i data-feather="film"></i>
                                            <span class="add-to-cart">Read More</span>
                                        </a>
                                        <a :href="routes.disputesLetterUrl.replace(':letter_id', letter.id)" type="button" class="btn btn-primary btn-cart">
                                            <i data-feather="file-text"></i>
                                            <span class="add-to-cart">Create Letter</span>
                                        </a>
                                    </div>
                                    <div v-else class="item-options pro-plan text-center">
                                        <a :href="routes.billingPlansUrl" type="button" class="btn btn-primary waves-effect waves-light btn-cart">
                                            <span class="">Subscribe To A Plan</span>
                                        </a>
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                        <hr />
                    </template>
                    <div v-else class="grid-view">

                        <transition v-for="(letter, index) in letters[disputeCenterActiveTab]">
                            <div class="card ecommerce-card">
                                <div class="item-img text-center">
                                    <a href="#" style="position:relative;" id="letter_image_fluid">
                                        <img :src="letter.image_url" class="img-fluid" alt="img-placeholder" v-if="letter.image_url != null"/>
                                        <img :src="letter.letter_image" class="img-fluid" alt="img-placeholder" />
                                        <div class="videoPlayBox" @click="openVideModel(letter.video_type, letter.letter_video,letter.name)">
                                            <vue-feather width="28px" height="28px" type="play-circle" class="letters_icons"></vue-feather>
                                        </div>
                                    </a>
                                </div>
                                <div class="card-body">
                                    <div class="item-wrapper">
                                        <div class="item-rating">
                                            {{ letter.letter_type }}
                                        </div>
                                        <div class="item-cost">
                                            <p class="item-price">
                                                <transition>
                                                    <span v-if="letter.dispute_flow_round === 'Pre-Dispute'" class="badge badge-secondary badge-glow company-name">
                                                        {{ letter.dispute_flow_round }}
                                                    </span>
                                                    <span v-else-if="letter.dispute_flow_round === 'Round 1'" class="badge badge-info badge-glow company-name">
                                                        {{ letter.dispute_flow_round }}
                                                    </span>
                                                    <span v-else-if="letter.dispute_flow_round === 'Round 2'" class="badge badge-success badge-glow company-name">
                                                        {{ letter.dispute_flow_round }}
                                                    </span>
                                                    <span v-else-if="letter.dispute_flow_round === 'Round 3'" class="badge badge-primary badge-glow company-name">
                                                        {{ letter.dispute_flow_round }}
                                                    </span>
                                                    <span v-else-if="letter.dispute_flow_round === 'Round 4'" class="badge badge-warning badge-glow company-name">
                                                        {{ letter.dispute_flow_round }}
                                                    </span>
                                                    <span v-else-if="letter.dispute_flow_round === 'Response'" class="badge badge-light-danger badge-glow company-name">
                                                        {{ letter.dispute_flow_round }}
                                                    </span>
                                                    <span v-else-if="letter.dispute_flow_round === 'Complaint'" class="badge badge-danger badge-glow company-name">
                                                        {{ letter.dispute_flow_round }}
                                                    </span>
                                                    <span v-else class="badge badge-danger badge-glow company-name">
                                                        {{ letter.dispute_flow_round }}
                                                    </span>

                                                </transition>

                                            </p>
                                        </div>
                                    </div>
                                    <div class="item-name">
                                        <a href="">
                                            {{ letter.name }}
                                        </a>
                                    </div>
                                </div>
                                <div class="item-options text-center" v-if="caneditallletter">
                                    <a class="btn btn-success btn-cart" @click="toggleEditor(letter.id)">
                                        <i data-feather="edit"></i>
                                        <span class="add-to-cart">Edit Letter</span>
                                    </a>
                                </div>
                                <div v-if="canCreateLetter" class="item-options text-center">
                                    <a :href="routes.letterTutorialUrl.replace(':letter_id', letter.id)" class="btn btn-light btn-cart">
                                        <i data-feather="film"></i>
                                        <span class="add-to-cart">Read More</span>
                                    </a>
                                    <a :href="routes.disputesLetterUrl.replace(':letter_id', letter.id)" type="button" class="btn btn-primary btn-cart">
                                        <i data-feather="file-text"></i>
                                        <span class="add-to-cart">Create Letter</span>
                                    </a>
                                </div>
                                <div v-else class="item-options pro-plan text-center">
                                    <a :href="routes.billingPlansUrl" type="button" class="btn btn-primary waves-effect waves-light btn-cart">
                                        <span class="">Subscribe To A Plan</span>
                                    </a>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
                </KeepAlive>
            </div>
        </div>
    </div>
    <EditModal :openModal="editModalStatus" :canEdit="caneditallletter" :openModalMethod="toggleEditor" :letterdata="letterdata" :letterVideoType="letterVideoType"/>
    <videoPlayer :id="'video-player'" :videoData="videoData"/>
</template>

<script>
    import { reactive } from 'vue'
    import { ref } from 'vue'
    import { Swiper, SwiperSlide } from 'swiper/vue';
    // import { Navigation, Pagination } from "swiper";
    import { Navigation, Pagination } from 'swiper/modules';
    import EditModal from './modals/EditModal.vue'
    import videoPlayer from './modals/videoPlayer.vue'
    import { openModal } from '../utilities/_helpers'
    import 'swiper/css';
    import 'swiper/css/navigation';
    import 'swiper/css/pagination';
    import '../../css/base/plugins/extensions/ext-component-swiper.css';
import axios from 'axios';
    export default {
        props: {
            routes: {
                type: [Array, Object]
            },
            canCreateLetter: {
                type: Boolean
            },
            caneditallletter: {
                type: Boolean
            }
        },
        components: {
            Swiper,
            SwiperSlide,
            EditModal,
            videoPlayer
        },
        setup() {
            return {
                editModalStatus: ref(false),
                letterdata: ref({}),
                videoData: ref({}),
                letterVideoType: ref(null),
                modules: [Navigation, Pagination],
                openModal: openModal
            };
        },
        data() {
            const letters = reactive({}), disputeCenterActiveTab = ref(false), isLoading = ref(true);
            return {
                letters,
                disputeCenterActiveTab,
                isLoading
            }
        },
        mounted() {
            this.disputeCenterActiveTab = localStorage.getItem('disputeCenterActiveTab');
            this.disputeCenterActiveTab = (this.disputeCenterActiveTab == null) ? 'cf-disputes-flow' : this.disputeCenterActiveTab;
            this.isLoading = true;
            let route = this.$router.resolve({
                name: 'dispute-center-letters',
                params: {
                    type: this.disputeCenterActiveTab
                }
            });
            axios.get(route.href)
            .then(response => {
                this.letters[this.disputeCenterActiveTab] = response.data.data;
                this.isLoading = false;
            });
        },
        methods: {
            shiftTab(type) {
                localStorage.setItem('disputeCenterActiveTab', type);
                this.disputeCenterActiveTab = type;
                if (
                    (typeof this.letters[this.disputeCenterActiveTab] == 'undefined')
                    ||
                    (this.letters[this.disputeCenterActiveTab].length < 1)
                ) {
                    this.isLoading = true;
                    let route = this.$router.resolve({
                        name: 'dispute-center-letters',
                        params: {
                            type: type
                        }
                    });
                    axios.get(route.href)
                    .then(response => {
                        this.letters[this.disputeCenterActiveTab] = response.data.data;
                        this.isLoading = false;
                    });
                }
            },
            onSwiper (swiper) {
                // console.log(swiper);
            },
            onSlideChange () {
                // console.log('slide change');
            },
            toggleEditor(letter_id){
                if(this.editModalStatus == true){
                    this.editModalStatus = false
                }else{
                    let $this = this;
                    this.editModalStatus =true
                    axios.post('disputes/editLetter',{letter_id}).then(({data})=>{
                        $this.letterdata = data.data
                        $this.letterVideoType = data.data.video_type
                    }).catch()
                }
            },
            openVideModel(videoType, letterVideo,letterName){
                this.videoData ={
                    type: videoType,
                    source: letterVideo,
                    title: letterName
                }
                openModal(`#video-player`);
            }

        }
    }
</script>
<style>
.videoPlayBox{
    height: 100%;
    width: 100%;
    background: #f5f5f529;
    position: absolute;
    top: 0px;
    left: 0px;
}
.letters_icons{
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    -o-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    color: #ffffff;
    height: 68px;
    width: 68px;
    cursor: pointer;
}
#letter_image_fluid .videoPlayBox{
    visibility: hidden;
    opacity:0;
    transition: opacity ease-in-out 0.5s;
    -webkit-transition: opacity ease-in-out 0.5s;
    -moz-transition: opacity ease-in-out 0.5s;
    -o-transition: opacity ease-in-out 0.5s;
}
#letter_image_fluid:hover .videoPlayBox{
    visibility: visible;
    opacity: 1;
}
</style>
